<template>
  <div>
    <ValidationObserver ref="observer" v-slot="{ invalid, validate }">
      <form role="form" @submit.stop.prevent="validate().then(submitForm)">
        <div class="vx-row">
          <div class="vx-col mb-6">
            <span>Ativo</span>
            <vs-switch
              color="success"
              v-model="formData.isActive"
              style="width: 60px"
            >
              <span slot="on">Ativo</span>
              <span slot="off">Inativo</span>
            </vs-switch>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <ValidationProvider
              name="Nome"
              rules="required"
              v-slot="{ errors }"
            >
              <label class="label-text">Nome</label>
              <vs-input
                size="large"
                class="w-full"
                name="name"
                id="name"
                v-model="formData.name"
                :danger="!!errors.length"
              />
              <span v-show="!!errors.length" class="text-danger"
                >{{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <ValidationProvider
              name="Código Susep"
              :rules="`required|max:${SUSEP_CODE_MAX_LENGTH}`"
              v-slot="{ errors }"
            >
              <label class="label-text">Código Susep</label>
              <vs-input
                size="large"
                class="w-full"
                name="Código Susep"
                id="codigo-susep"
                v-model="formData.susepCode"
                :danger="!!errors.length"
                :maxlength="SUSEP_CODE_MAX_LENGTH"
              />
              <span v-show="!!errors.length" class="text-danger"
                >{{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <label class="vs-select--label">ID I4Pro</label>
            <vs-select
              v-model="formData.idI4pro"
              class="select-large w-full"
              name="idI4pro"
              id="idI4pro"
            >
              <vs-select-item :value="null" text="Selecione" />
              <vs-select-item
                v-for="(option, index) in i4proOptions"
                :key="`i4pro-option-${index}`"
                :value="option.value"
                :text="option.label"
              />
            </vs-select>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full text-right">
            <vs-button
              color="warning"
              type="border"
              class="mr-3 mb-2"
              @click.stop.prevent="onReset"
              >Cancelar</vs-button
            >
            <BotaoSubmit
              variant="success"
              :edit="!!congener.id"
              :aguarde="isLoading"
              :disabled="invalid"
            ></BotaoSubmit>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>
<script>
import BotaoSubmit from '@/components/BotaoSubmit.vue';
import congenerApi from '@/services/congener.api';
import i4proApi from '@/services/i4pro.api';
import notify from '@/utils/notify';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

const SUSEP_CODE_MAX_LENGTH = 4;

export default {
  name: 'FormCongener',
  components: {
    ValidationProvider,
    ValidationObserver,
    BotaoSubmit,
  },
  props: {
    congener: {
      type: Object,
      default: () => ({}),
    },
    sideBar: {
      type: Boolean,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: this.resetForm(),
      isLoading: false,
      i4proOptions: [],
      i4proOptionsLoading: false,
      SUSEP_CODE_MAX_LENGTH,
    };
  },
  mounted() {
    this.loadI4proOptions();
  },
  methods: {
    async submitForm() {
      this.isLoading = true;
      if (this.congener.id) {
        await this.updateCongener();
      } else {
        await this.createCongener();
      }
      this.isLoading = false;
    },
    async updateCongener() {
      try {
        const data = await congenerApi.updateCongener(
          this.congener.id,
          this.formData,
        );
        notify.notifySuccess(this.$vs, 'Congênere atualizado com sucesso!');
        this.$emit('concluido', data);
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          notify.notifyFail(this.$vs, error.response.data.message);
        } else {
          notify.notifyFail(this.$vs, error);
        }
      }
    },
    async createCongener() {
      try {
        const data = await congenerApi.createCongener(this.formData);
        notify.notifySuccess(this.$vs, 'Congênere criado com sucesso!');
        this.$emit('concluido', data);
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          notify.notifyFail(this.$vs, error.response.data.message);
        } else {
          notify.notifyFail(this.$vs, error);
        }
      }
    },
    resetForm() {
      return {
        isActive: true,
        name: '',
        susepCode: '',
        idI4pro: null,
      };
    },
    async loadI4proOptions() {
      if (this.i4proOptionsLoading || this.i4proOptions.length > 0) {
        return;
      }
      this.i4proOptionsLoading = true;
      try {
        const options = await i4proApi.getOptions('id_pessoa_congenere');
        this.i4proOptions = Array.isArray(options) ? options : [];
      } catch (error) {
        notify.notifyFail(this.$vs, 'Erro ao buscar opções do I4Pro');
      } finally {
        this.i4proOptionsLoading = false;
      }
    },
    fillForm() {
      if (this.congener && Object.keys(this.congener).length > 0) {
        this.formData = {
          id: this.congener.id,
          isActive: !this.congener.deletedAt,
          name: this.congener.name,
          susepCode: this.congener.susepCode,
          idI4pro: this.congener.idI4pro,
        };
      } else {
        this.formData = this.resetForm();
      }
    },
    onReset(event) {
      this.$nextTick(() => {
        this.$refs.observer.reset();
      });
      if (this.sideBar === true) {
        this.$emit('cancel');
      } else {
        event.preventDefault();
        this.$nextTick(() => {
          this.show = true;
        });
      }
    },
  },
  watch: {
    congener: {
      handler() {
        this.fillForm();
      },
    },
    active: {
      immediate: true,
      handler(newValue) {
        if (newValue === true) {
          this.fillForm();
          this.loadI4proOptions();
        }
      },
    },
  },
};
</script>
